import React, { useEffect, useReducer, useState } from 'react'
import Countdown from "react-countdown";
import { Button, LinearProgress, } from "@material-ui/core";
import moment from "moment";
function CounterProgress({ handler }) {

    const waitingTime = 120000;
    // const waitingTime = 10000;
    const [counterRemained, setCounterRemained] = useState(waitingTime);
    
    const [times, setTimes] = useState([moment().add(waitingTime , 'ms'),moment().add(2 * waitingTime , 'ms')]);
    // const [times, setTimes] = useState([Date.now() + waitingTime, Date.now() + 2 * waitingTime]);
    // const [currentTime, setCurrentTime] = useState(Date.now() + counterRemained);
    const [currentTime, setCurrentTime] = useState(moment().add(counterRemained , 'ms'));
    const [currentTimeIndex, setCurrentTimeIndex] = useState(0);
    const [resend, setResend] = useState(-1);

    useEffect(() => {
        // resend sms to user
        if (resend === 0) {
            // console.log("salam",times);
            handler();
            setResend(-1)
            setCurrentTimeIndex(currentTimeIndex + 1);
            // setCurrentTime(new Date(times[currentTimeIndex + 1]));
            setCurrentTime(moment().add(counterRemained , 'ms'));
        }

    }, [resend])

    const counterRenderer = ({ minutes, seconds, completed, total }) => {
        setCounterRemained(120000);
        // setCounterRemained(10000);
        const mainMin = waitingTime;
        const onePercent = mainMin / 100;
        const leftedPercent = total / onePercent;
        return (
            <>
                {
                    resend && (
                        <>
                            <LinearProgress
                                variant="determinate"
                                value={leftedPercent}
                                dir="ltr"
                                style={{ height: "0.7rem", borderRadius: "10px" }}
                                className={` w-75 mx-auto`}
                            />
                            <div style={{
                                display: "block",
                                marginLeft: "auto",
                                marginRight: "auto",
                            }}>
                                <Button
                                    disabled={total >= 1}
                                    style={counterRemained === 0 ? { textColor: "#6dd06d" } : {}}
                                    onClick={() => {
                                        setResend(0)
                                    }}
                                >
                                    ارسال مجدد کد: {"  "}
                                </Button>
                                <span style={{ textColor: "black", fontSize: "10px" }}>{minutes}:{seconds}</span>
                            </div>
                        </>

                    )
                }
            </>
        );
    };


    return (
        <>
            <Countdown
                date={currentTime}
                key={currentTimeIndex}
                renderer={counterRenderer}
                onComplete={() => {
                    if (times.length - 1 <= times.indexOf(currentTime)) return;
                }}
            />
        </>
    );
}

export default CounterProgress;